import I18n from 'I18n';
import { TOPIC_NAMES } from 'crm-message-bus/types/MessageTopics';
import { useSendCrmMessageTopic } from 'crm-message-bus/useSendCrmMessageTopic';
import { useEnrichmentActionPolicies, EnrichmentActionsTooltip, SmartFillActionsTooltip } from 'enrichment-properties-lib/components/EnrichmentActions';
import { COMPANY_TYPE_ID, CONTACT_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import { jsx as _jsx } from "react/jsx-runtime";
const upgradeSources = {
  [COMPANY_TYPE_ID]: 'enrich-action-company',
  [CONTACT_TYPE_ID]: 'enrich-action-contact'
};
export const useEnrichmentMenuItem = ({
  hasScope,
  isUngated: hasGate,
  objectId,
  objectTypeId
}) => {
  const {
    canUpgrade,
    canUpgradeDataAgent,
    enrichmentIcon,
    isDisabled,
    isDataAgentDisabled,
    showSmartFillContact
  } = useEnrichmentActionPolicies({
    hasGate,
    hasScope
  });
  const openEnrichmentPropertiesPanel = useSendCrmMessageTopic(TOPIC_NAMES.OPEN_ENRICHMENT_PROPERTIES_PANEL);
  const openSmartPropertiesPanel = useSendCrmMessageTopic(TOPIC_NAMES.OPEN_SMART_PROPERTIES_PANEL);
  const isContact = objectTypeId === CONTACT_TYPE_ID;
  const isCompany = objectTypeId === COMPANY_TYPE_ID;
  const showMenuItem = isContact || isCompany;
  const iconNameEnrichment = isDisabled ? 'locked' : enrichmentIcon;
  const iconNameSmartProperties = isDataAgentDisabled ? 'locked' : enrichmentIcon;
  const TooltipEnrichment = () => /*#__PURE__*/_jsx(EnrichmentActionsTooltip, {
    canUpgrade: canUpgrade,
    upgradeSource: upgradeSources[objectTypeId]
  });
  const TooltipSmartProperties = () => /*#__PURE__*/_jsx(SmartFillActionsTooltip, {
    canUpgrade: canUpgradeDataAgent,
    upgradeSource: upgradeSources[objectTypeId]
  });
  const enrichmentMenuItemConfig = {
    disabled: isDisabled,
    iconName: iconNameEnrichment,
    label: I18n.text('cardProperties.cardActions.enrichRecord'),
    onClick: () => {
      openEnrichmentPropertiesPanel({
        objectTypeId,
        objectId
      });
    },
    tooltipText: isDisabled ? /*#__PURE__*/_jsx(TooltipEnrichment, {}) : null,
    type: 'button'
  };
  let enrichmentMenuItems = [];
  if (showMenuItem) {
    enrichmentMenuItems = [{
      type: 'divider'
    }, Object.assign({}, enrichmentMenuItemConfig)];
  }
  let shouldShowSmartPropertiesAction = showMenuItem;
  if (showMenuItem && showSmartFillContact && isContact) {
    shouldShowSmartPropertiesAction = true;
  }
  const smartPropertiesMenuItemConfig = {
    type: 'button',
    disabled: isDisabled,
    iconName: iconNameSmartProperties,
    label: I18n.text('cardProperties.cardActions.runSmartProperties'),
    onClick: () => {
      openSmartPropertiesPanel({
        objectTypeId,
        objectId
      });
    },
    tooltipText: isDataAgentDisabled ? /*#__PURE__*/_jsx(TooltipSmartProperties, {}) : null
  };
  if (shouldShowSmartPropertiesAction) {
    enrichmentMenuItems.push(smartPropertiesMenuItemConfig);
  }
  return {
    enrichmentMenuItems,
    enrichmentMenuItemConfig,
    smartPropertiesMenuItemConfig,
    showSmartPropertiesActions: shouldShowSmartPropertiesAction
  };
};